<div class="repairer-manager col-md-12" ngxUiLoaderBlurred [loaderId]="'loader-principal'">
    <app-header
        [title]="'repairer-manager.configuracoes.titulo' | translate"
        [hasBackButton]="false"
        [hasButtons]="false"
    ></app-header>
    <div class="card card-default col-md-12">
        <ng-scrollbar>
            <div role="tabpanel">
                <div class="formulario">
                    <fieldset>
                        <legend>{{ 'repairer-manager.configuracoes.auditoria_compras' | translate}}</legend>
                        <div class="mb-3 form-group form-control-height">
                            <div class="col-sm-2 col-md-2">
                                <label>{{ 'repairer-manager.configuracoes.limite_minimo_auditoria.label' | translate}}</label>
                                <div class="input-group">
                                    <span class="input-group-text">R$</span>
                                    <input type="text" class="form-control" [(ngModel)]="limite_minimo_auditoria" (ngModelChange)="modelChange()" [ngClass]="{'is-invalid': submitted && hasError }" currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',' }" maxlength="10">
                                </div>
                                @if (submitted && hasError) {
                                    <span class="text-danger">
                                        {{ 'repairer-manager.configuracoes.limite_minimo_auditoria.obrigatorio' | translate }}
                                    </span>
                                }
                            </div>
                        </div>
                    </fieldset>
                    <div class="col-sm-12 col-md-12">
                        <button id="salvar" type="submit" class="btn btn-primary btn-lg" (click)="salvar(0)">{{ 'repairer-manager.configuracoes.botoes.salvar' | translate}}</button>
                    </div>
                </div>
            </div>
        </ng-scrollbar>
    </div>
</div>
<ngx-ui-loader [loaderId]="'loader-principal'"></ngx-ui-loader>



